import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IDirectDealFilter } from '../../constants/filter/directDealFilter.constant';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';
import { useAppSelector } from '../store/useStore';

const OPTIONAL_SEARCH_PARAM_KEYS = [
  'minEngineOutputPs',
  'maxEngineOutputPs',
  'minPrice',
  'maxPrice',
  'minManufacturedYear',
  'maxManufacturedYear',
  'minOperationTime',
  'maxOperationTime',
  'recentDays',
  'region',
];

export const useUpdateDirectDealListPageSearchParam = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const directDealFilterStates = useAppSelector((state) => state.filter.directDealFilter);

  useEffect(() => {
    if (directDealFilterStates.isSearchParamChecked && directDealFilterStates.globalFilters) {
      const existingParams = Object.fromEntries(searchParams.entries());

      const newFilterParams = createSearchParamBySelectedFilterOption({
        filterType: 'directDealFilter',
        filters: directDealFilterStates.globalFilters as IDirectDealFilter[],
      });

      // '제한 없음'이나 해제로 사라진 조건이 URL에 남지 않도록, 값이 없을 수 있는 키는 먼저 지운다.
      OPTIONAL_SEARCH_PARAM_KEYS.forEach((key) => delete existingParams[key]);

      const mergedParams = {
        ...existingParams,
        ...newFilterParams,
      };

      const newSearchParams = new URLSearchParams(mergedParams).toString();

      navigate(`${pageInfo.openMarketListPage.path}?${newSearchParams}`, {
        replace: true,
      });
    }
  }, [directDealFilterStates.globalFilters, directDealFilterStates.isSearchParamChecked, searchParams, navigate]);
};
